// Shift-range selection reads the modifier OFF THE ORIGINATING EVENT — the
// React click for a press, `eventDetails.event` for a checkbox toggle. It
// must never come from tracked document-level key state: a keyup the page
// never receives (an OS screenshot chord, a focus steal, a native dialog)
// leaves "shift held" latched, and every later plain click silently becomes
// a range select.
export function eventShiftKey(event: Event): boolean {
  return "shiftKey" in event && event.shiftKey === true;
}
